// Generated file - do not touch manually
export const iconsMetaData = {
    "icon-academic-cap": "education graduation learning school",
    "icon-addressbook": "contacts phonebook directory list",
    "icon-ai": "ai artificial intelligence ki",
    "icon-air-pay": "contactless payment wireless transaction",
    "icon-am": "morning time clock period",
    "icon-angle-double-down": "arrow navigation dropdown",
    "icon-angle-double-left": "arrow backward rewind previous",
    "icon-angle-double-right": "arrow forward next skip",
    "icon-angle-double-up": "arrow scroll top navigation",
    "icon-antenna": "signal communication wireless",
    "icon-api": "integration development backend code",
    "icon-archive": "storage backup save history",
    "icon-area-chart": "graph statistics analytics data",
    "icon-area-in": "entry zone boundary",
    "icon-area-out": "exit zone boundary",
    "icon-arrow-down": "download navigate lower",
    "icon-arrow-left": "back return previous",
    "icon-arrow-right": "next forward move",
    "icon-arrow-up": "upload ascend navigate",
    "icon-arrows-collapse": "arrows collapse",
    "icon-arrows-combine": "arrows combine merge unify",
    "icon-arrows-expand": "arrows expand",
    "icon-arrows-horizontal": "arrows horizontal",
    "icon-arrows-split": "arrows split branch",
    "icon-assigned": "user assigned",
    "icon-axis-x": "axis-x coordinate",
    "icon-axis-y": "axis-y coordinate",
    "icon-axis-z": "axis-z coordinate",
    "icon-axle": "wheel vehicle transport",
    "icon-ban-circle": "prohibited restricted stop forbidden",
    "icon-bar-chart-box": "bar chart box",
    "icon-battery-charging": "battery charging bev",
    "icon-battery-level-empty": "low power charge warning",
    "icon-battery-level-full": "fully charged power",
    "icon-battery-level-low": "low charge warning",
    "icon-beacon": "signal tracking positioning gps trailer",
    "icon-big-bag": "big bag bulk sack freight cargo logistics",
    "icon-book": "reading literature knowledge",
    "icon-bookable-poi": "reservation location place",
    "icon-bookmark-square": "save favorite highlight",
    "icon-bookmark": "favorite highlight saved",
    "icon-border-crossing": "customs checkpoint travel",
    "icon-box-open": "box open package parcel",
    "icon-box": "box package parcel",
    "icon-brain": "brain",
    "icon-brake": "stop safety vehicle",
    "icon-branch-horizontal": "branch horizontal",
    "icon-branch-remove": "branch remove",
    "icon-branch-vertical": "branch vertical",
    "icon-broadcast": "broadcast",
    "icon-building": "architecture office home structure",
    "icon-bulb": "light bulb",
    "icon-bulk-container": "bulk container cargo freight logistics storage",
    "icon-bus-baseline": "public transport commute",
    "icon-bus-breakdown": "vehicle failure stop",
    "icon-bus": "transport public commute travel",
    "icon-businessman": "corporate work professional",
    "icon-calendar-parking": "reservation schedule booking",
    "icon-calendar-plus": "add event schedule",
    "icon-calendar-today": "current date reminder",
    "icon-calendar": "schedule date events",
    "icon-camera": "photo video capture",
    "icon-car-baseline": "vehicle transport automobile",
    "icon-car-wash": "clean vehicle service",
    "icon-car": "automobile transport drive",
    "icon-card-hotel": "access key entry",
    "icon-card-reader": "payment swipe scanner",
    "icon-cards-add": "new add payment banking",
    "icon-cards-grid": "layout display options",
    "icon-cards-list": "menu display items",
    "icon-cards-table": "data information structured",
    "icon-cargo": "freight transport goods shipment",
    "icon-carrier": "logistics transport shipment",
    "icon-chat": "message communication talk",
    "icon-check-badge": "verified approved trusted",
    "icon-check-shield": "security verified safe",
    "icon-checkbox-checked": "selected confirmed approved",
    "icon-checkbox": "option select choice",
    "icon-checkboxes": "multiple selection options",
    "icon-chevron-down": "arrow expand dropdown lower",
    "icon-chevron-left": "arrow previous back rewind",
    "icon-chevron-right": "arrow next forward skip",
    "icon-chevron-up": "arrow collapse expand move up",
    "icon-chip": "chip silicon",
    "icon-circle-dashed": "circle dashed",
    "icon-circle-stack": "layers data archive",
    "icon-click": "press interaction tap",
    "icon-climate-control": "temperature settings comfort",
    "icon-clipboard": "notes copy list task",
    "icon-cloud-download": "backup retrieve save storage",
    "icon-cloud-not-saved": "unsaved warning lost data",
    "icon-cloud-progress": "cloud progress",
    "icon-cloud-upload": "store sync backup",
    "icon-cloud": "online network storage",
    "icon-coasting": "glide drive motion smooth",
    "icon-code-braces": "development programming syntax",
    "icon-code-brackets": "html css coding",
    "icon-coffee": "coffee cup",
    "icon-cog": "settings gear adjust",
    "icon-coil": "coil roll cable steel goods material",
    "icon-color-swatch": "palette design theme",
    "icon-comment": "message chat feedback",
    "icon-compare": "difference evaluate review",
    "icon-compass": "compass navigation",
    "icon-component-custom-recurrent": "repeat automation process",
    "icon-component-custom": "personalized settings modular",
    "icon-construction": "building work development",
    "icon-convert": "convert change",
    "icon-conveyor-belt": "conveyor belt",
    "icon-cookie": "data storage privacy",
    "icon-cooling": "air conditioning temperature",
    "icon-cost-efficiency": "cost efficiency hand euro",
    "icon-credit-card": "payment card credit debit bank billing purchase",
    "icon-crown": "crown",
    "icon-cruise-control": "auto speed drive assist",
    "icon-css": "css stylesheet styling frontend web",
    "icon-csv": "spreadsheet data export file",
    "icon-cube-dashed": "cube dashed package box",
    "icon-cube": "cube package box",
    "icon-currency-euro": "money finance exchange",
    "icon-damages": "loss accident insurance",
    "icon-dangerousgoods": "hazard shipping risk",
    "icon-dashboard-view": "dashboard view",
    "icon-dashboard": "control panel overview",
    "icon-delivery-completed": "tms transport shipment success package received",
    "icon-delivery-error": "tms transport failed shipment issue",
    "icon-delivery-late": "tms transport delayed shipping package",
    "icon-delivery-on-track": "tms transport on time scheduled shipping",
    "icon-delivery-warning": "tms transport issue caution shipment",
    "icon-delivery": "tms transport shipping package",
    "icon-design": "design drawing UI tool edit",
    "icon-desktop": "computer workstation pc",
    "icon-detail-view-info": "expanded details insights",
    "icon-detail-view": "information overview display",
    "icon-direction": "navigate route gps",
    "icon-discount-badge": "discount badge",
    "icon-document-out": "export file pdf",
    "icon-document": "file text report",
    "icon-download": "save retrieve file",
    "icon-drag-n-drop": "move reposition reorder arrange grab",
    "icon-drive-history": "trip log past journeys vehicle tracking",
    "icon-driver-card": "driver id license authentication",
    "icon-driver": "person operator vehicle chauffeur",
    "icon-drivercard-in": "entry login access verification",
    "icon-drivercard-out": "exit logout removal verification",
    "icon-duplicate": "copy clone replicate duplicate",
    "icon-earphone": "headphones audio music sound",
    "icon-emergency-stop": "emergency stop switch button",
    "icon-empty": "blank null missing unavailable",
    "icon-engine": "motor vehicle power mechanical",
    "icon-envelope-indicator": "mail email message letter communication unread indicator new",
    "icon-envelope-open": "mail email message letter communication read open",
    "icon-envelope": "mail email message letter communication unread closed",
    "icon-erase": "delete remove clear wipe",
    "icon-error-sign": "warning issue problem alert",
    "icon-euro-note": "currency money euro finance",
    "icon-exclamation-sign": "alert warning important notice",
    "icon-exclamation": "caution urgent attention",
    "icon-eye-close": "hide invisible privacy security",
    "icon-eye-closed": "eye closed",
    "icon-eye-open": "eye open visible",
    "icon-face-frown": "sad disappointed unhappy reaction emoji smiley",
    "icon-face-neutral": "expression normal indifferent reaction emoji smiley",
    "icon-face-smile": "happy joy pleased positive emoji smiley",
    "icon-facetime-video": "call conference communication camera",
    "icon-factory": "industry production manufacturing plant",
    "icon-file-signature": "document sign approve verify",
    "icon-files": "documents archive storage",
    "icon-fill": "complete input apply paint",
    "icon-filling-e-station": "charging electric vehicle energy",
    "icon-filling-station": "gas petrol refuel fuel",
    "icon-filter-active": "search refine results active",
    "icon-filter-reset": "reset filter",
    "icon-filter": "sort refine selection search",
    "icon-fingerprint": "biometric security authentication identity",
    "icon-finish": "complete done end task",
    "icon-fire": "flame heat emergency danger",
    "icon-flag": "marker country nation highlight",
    "icon-flash": "light electricity thunder bolt",
    "icon-folder-closed": "directory storage document private",
    "icon-folder-open": "directory storage document visible",
    "icon-fuel-electric": "charging vehicle power eco",
    "icon-fuel-gas": "petrol fuel station energy",
    "icon-fuel-hydrogen": "eco fuel cell refill energy",
    "icon-fuel-liquid": "gas refuel transport energy",
    "icon-fuel-mix": "fuel mix hybrid",
    "icon-fullscreen": "expand enlarge maximize view",
    "icon-geofence": "location boundary gps tracking",
    "icon-get": "download receive import receive",
    "icon-give": "send deliver export send",
    "icon-globe-alt": "globe",
    "icon-globe": "world internet international global",
    "icon-group-blocks": "group blocks",
    "icon-group": "people team organization users",
    "icon-hand-down": "gesture direction point lower",
    "icon-hand-left": "gesture direction point back",
    "icon-hand-right": "gesture direction point forward",
    "icon-hand-up": "gesture direction point raise",
    "icon-handshake": "agreement partnership deal contract",
    "icon-hash": "number tag identifier code",
    "icon-heart": "love favorite like emotion",
    "icon-heating": "temperature warm system climate",
    "icon-hierarchy": "hierarchy",
    "icon-history": "history time",
    "icon-home-sign": "address property real estate",
    "icon-home": "house residence living building",
    "icon-hour-glass": "time wait countdown sand",
    "icon-id": "identity card verification badge",
    "icon-inbox-in": "email receive message notification",
    "icon-inbox-out": "email send outgoing mail",
    "icon-inbox-stack": "messages communication storage",
    "icon-inbox": "mailbox messages email notifications",
    "icon-info-sign": "information help guidance knowledge",
    "icon-info": "details data explanation",
    "icon-insert": "insert add include place embed",
    "icon-issue-tracking": "issue tracking tasks",
    "icon-key": "security access unlock passcode",
    "icon-kickdown": "accelerate boost power vehicle",
    "icon-language": "translation multilingual speech",
    "icon-layer-pois": "map locations markers places",
    "icon-layer": "stack levels structure organization",
    "icon-leafs": "leafs green",
    "icon-light-bulb": "idea innovation brightness",
    "icon-line-chart": "graph statistics analytics data",
    "icon-link": "connection url chain reference",
    "icon-load-unload": "logistics delivery shipment",
    "icon-load": "transport goods cargo truck",
    "icon-location-arrow": "gps navigation find direction",
    "icon-lock-open": "unlocked security access safe",
    "icon-lock": "locked security safe private",
    "icon-log-in": "access entry authentication login",
    "icon-logout": "exit sign out disconnect",
    "icon-looking-glass-man": "search user inspect person",
    "icon-looking-glass": "magnify zoom find search",
    "icon-magic-wand": "magic wand automatic",
    "icon-maintenance-components": "repair fix settings tools",
    "icon-map-location": "gps direction pin navigation",
    "icon-map-marker": "location pin place gps",
    "icon-map": "navigation geography world places",
    "icon-megaphone": "announcement loudspeaker public address",
    "icon-menu-hamburger": "navigation sidebar options",
    "icon-merge": "combine integrate join union",
    "icon-mesh-box": "mesh box wire cage",
    "icon-migrate": "migrate change",
    "icon-milage": "distance fuel efficiency odometer",
    "icon-minus-light": "decrease subtract remove minimal",
    "icon-minus-sign": "negative reduce delete",
    "icon-minus": "subtract decrease remove",
    "icon-missing": "lost unavailable not found dashed",
    "icon-mode-dark-light": "theme night day toggle",
    "icon-more": "options expand additional",
    "icon-new-window": "open external link pop-up",
    "icon-newspaper": "news articles media",
    "icon-note": "note comments",
    "icon-notification": "alert message reminder",
    "icon-number-1": "one first priority",
    "icon-number-2": "two second ranking",
    "icon-number-3": "three third placement",
    "icon-off": "power disabled inactive",
    "icon-oil-can": "lubrication maintenance engine",
    "icon-ok-circle": "approved success confirmed",
    "icon-ok-dashed": "ok dashed pending",
    "icon-ok-sign": "checkmark confirm positive",
    "icon-ok": "yes valid verified",
    "icon-onboarding": "setup introduction start",
    "icon-ongoing": "progress active continuing",
    "icon-option-horizontal": "settings choices selection",
    "icon-option-vertical": "preferences list customization",
    "icon-order": "sequence arrangement structured",
    "icon-palette-broken": "color error damaged",
    "icon-palette-empty": "palette empty pallet",
    "icon-palette": "design colors theme",
    "icon-paper-clip": "attachment document file",
    "icon-parcel-broken": "damaged package shipping box",
    "icon-parcel": "package delivery shipping box",
    "icon-parking": "car stop vehicle lot",
    "icon-pause-circle": "stop hold break",
    "icon-pause": "halt freeze temporary stop",
    "icon-pdf-file": "document portable format",
    "icon-pencil-square": "edit modify update",
    "icon-pencil": "write draw sketch",
    "icon-phone": "call contact communication",
    "icon-pictures": "images photos gallery",
    "icon-pin-range": "location distance area",
    "icon-pin": "location marker place",
    "icon-play-circle": "start video audio media",
    "icon-play": "begin start media",
    "icon-plugged-off": "unplug disconnect power",
    "icon-plugged-on": "connected power charging",
    "icon-plus-light": "increase add expand",
    "icon-plus-sign": "positive addition",
    "icon-plus": "add more expand",
    "icon-pm": "afternoon evening time",
    "icon-poi": "point of interest location",
    "icon-polygon": "shape boundary area",
    "icon-position": "location placement coordinate",
    "icon-print": "document paper hardcopy",
    "icon-progress-ongoing": "process running active",
    "icon-progress-remaining": "incomplete pending left",
    "icon-progression": "progression chart",
    "icon-prompt": "code prompt",
    "icon-pto-off": "power take-off disabled",
    "icon-pto-on": "power take-off engaged",
    "icon-pushpin": "pin marker location",
    "icon-puzzle": "challenge problem-solving pieces",
    "icon-pylon": "tower structure electricity",
    "icon-qr-code": "barcode scan digital",
    "icon-question-sign": "help assistance inquiry",
    "icon-question": "faq ask information",
    "icon-record": "audio video capture",
    "icon-recycle": "recycle reuse",
    "icon-refresh": "reload update reset",
    "icon-remove-circle": "delete cancel reject",
    "icon-remove-sign": "close dismiss exit",
    "icon-remove": "delete subtract clear",
    "icon-repeat-square": "repeat square",
    "icon-repeat": "redo replay loop",
    "icon-resize-full": "expand maximize enlarge",
    "icon-resize-horizontal": "adjust width stretch",
    "icon-resize-small": "minimize shrink reduce",
    "icon-resize-vertical": "adjust height scale",
    "icon-retrofit": "upgrade modify improve",
    "icon-revert": "undo restore previous",
    "icon-rio-marker": "map pin navigation",
    "icon-rio": "branding logo company",
    "icon-road-restrictions": "traffic limits block",
    "icon-road": "street highway travel",
    "icon-robot": "automation ai machine",
    "icon-rocket": "launch space fast",
    "icon-role-management": "permissions access users",
    "icon-roll-container": "roll container trolley cage cart logistics",
    "icon-route-option": "directions alternative path",
    "icon-route-view": "map navigation tracking",
    "icon-route": "path journey gps",
    "icon-ruler": "measurement scale distance",
    "icon-satellite-radar": "satellite radar event sender broadcast",
    "icon-save": "store backup keep",
    "icon-scale": "size measurement balance",
    "icon-scan": "barcode qr detect",
    "icon-scissors": "cut trim edit",
    "icon-search-list": "find results filter",
    "icon-search-truck": "vehicle gps locate",
    "icon-search": "find lookup query",
    "icon-send": "submit deliver transfer",
    "icon-series": "sequence order steps",
    "icon-server-stack": "data center cloud hosting",
    "icon-settings": "preferences gear configuration options",
    "icon-share-alt": "send distribute forward social",
    "icon-share-nodes": "connect network distribute social",
    "icon-share": "send forward distribute",
    "icon-shelve-empty": "shelf empty storage warehouse rack logistics",
    "icon-shelve": "shelve rack",
    "icon-ship": "boat vessel cargo transport",
    "icon-shopping-bag": "purchase store retail commerce",
    "icon-shopping-cart": "buy purchase checkout basket",
    "icon-signature": "autograph approve document sign",
    "icon-slope-down-max": "steep decline gradient",
    "icon-slope-down-min": "gentle decline gradient",
    "icon-slope-up-max": "steep incline gradient",
    "icon-slope-up-min": "gentle incline gradient",
    "icon-sort-by-attributes-alt": "arrange order filter",
    "icon-sort-by-attributes": "organize rank sequence",
    "icon-sort": "order arrange prioritize",
    "icon-sparkles": "glow shine effect magic",
    "icon-speed": "velocity fast quick performance",
    "icon-sphere": "globe round shape world",
    "icon-spinner": "loading processing wait animation",
    "icon-split-view": "dual screen compare layout",
    "icon-square-dashed": "square dashed",
    "icon-stack-add": "stack add",
    "icon-stack-iso": "layers stack",
    "icon-stack": "layers pile grouped",
    "icon-star-empty": "favorite like outline",
    "icon-star": "favorite like highlight",
    "icon-stars": "rating favorite review",
    "icon-start": "begin initiate launch",
    "icon-stats-high": "stats high",
    "icon-stats-line-dots": "stats line dots",
    "icon-stats-low": "stats low",
    "icon-stats-medium": "stats medium",
    "icon-stats": "analytics data metrics graph",
    "icon-status-available": "online active ready",
    "icon-status-change-horizontal": "status change horizontal",
    "icon-status-change": "status change",
    "icon-status-driving": "moving vehicle on the road",
    "icon-status-resting": "paused stopped inactive",
    "icon-status-working": "active engaged in task",
    "icon-steering-wheel": "vehicle drive control",
    "icon-stillage": "stillage rack frame pallet cargo transport",
    "icon-stopover": "layover pause rest",
    "icon-support": "help assistance customer service",
    "icon-table-view": "grid data spreadsheet list",
    "icon-tachograph-download": "log data report compliance",
    "icon-tachograph": "vehicle log driving time",
    "icon-tag": "label identifier marker",
    "icon-tasks": "to-do list jobs assignments",
    "icon-temperature": "heat climate weather degrees",
    "icon-th-list": "items structure layout",
    "icon-thumbs-down": "dislike reject negative feedback",
    "icon-thumbs-up": "approve like positive feedback",
    "icon-tickets": "event pass admission coupon",
    "icon-time-alt": "clock timer schedule alternative",
    "icon-time-cancle": "stop remove clock cancel",
    "icon-time-incomplete": "time incomplete",
    "icon-time": "clock timer schedule",
    "icon-tire": "wheel vehicle rubber traction",
    "icon-tms": "transportation tracking logistics",
    "icon-to-bottom": "navigate down end",
    "icon-to-left": "navigate back previous",
    "icon-to-right": "navigate forward next",
    "icon-to-top": "navigate up start",
    "icon-tracking-package": "tracking package",
    "icon-traffic-lights": "signal stoplight road safety",
    "icon-trailer-baseline": "transport attach tow",
    "icon-trailer-liquid": "liquid trailer tanker truck",
    "icon-trailer-standard": "standard trailer truck",
    "icon-trailer-tipping": "tipping trailer dump truck",
    "icon-trailer": "cargo transport vehicle",
    "icon-trailerposition": "placement logistics alignment",
    "icon-train": "railway transport locomotive rail",
    "icon-transfer": "move shift relocate",
    "icon-transition-push-right": "transition push right change",
    "icon-transition-right": "transition right change",
    "icon-trash-open": "trash open delete remove bin waste",
    "icon-trash": "delete remove discard",
    "icon-triangle-bottom": "direction down arrow",
    "icon-triangle-left": "direction back previous arrow",
    "icon-triangle-right": "direction next forward arrow",
    "icon-triangle-top": "direction up arrow",
    "icon-trophy": "award prize achievement",
    "icon-truck-baseline": "transport freight delivery",
    "icon-truck-breakdown": "malfunction vehicle repair",
    "icon-truck-unit": "transport freight logistics",
    "icon-truck": "freight transport logistics vehicle",
    "icon-unassigned": "user unassigned",
    "icon-unavailable": "unavailable",
    "icon-unlink": "disconnect break remove",
    "icon-upload": "send transfer file",
    "icon-user-add": "new member profile account",
    "icon-user-group": "team people community members",
    "icon-user-ok": "verified approved confirmed profile",
    "icon-user-remove": "delete profile remove account",
    "icon-user-sign-off": "logout exit disconnect",
    "icon-user-sign": "account login identification",
    "icon-user": "profile person account",
    "icon-van-baseline": "vehicle transport delivery",
    "icon-van": "transport cargo delivery vehicle",
    "icon-variable": "variable code",
    "icon-video": "video",
    "icon-volume": "sound audio speaker loudness",
    "icon-wallet": "money finance payment",
    "icon-warehouse": "building warehouse",
    "icon-warning-sign": "alert caution danger risk",
    "icon-weather-cloudy": "forecast overcast grey sky",
    "icon-weather-icy": "cold freeze slippery frost",
    "icon-weather-overcast": "grey cloudy dull sky",
    "icon-weather-raining": "rain shower precipitation",
    "icon-weather-snowing": "snowflakes winter cold weather",
    "icon-weather-stormy": "thunder lightning severe",
    "icon-weather-sunny": "clear hot bright sunshine",
    "icon-weather-thundering": "lightning storm thunder",
    "icon-weather-windy": "breezy gust airflow",
    "icon-weight": "mass measurement load scale",
    "icon-width": "size dimension horizontal measurement",
    "icon-wifi": "wireless internet connection network",
    "icon-window": "frame display view screen",
    "icon-workflow-step": "workflow step",
    "icon-workflow": "workflow",
    "icon-workshop": "training repair hands-on session",
    "icon-wrench": "tool repair fix maintenance",
    "icon-xmas-raindeer": "holiday christmas festive",
    "icon-xmas-santa": "christmas holiday gift festive"
};
